import React from 'react'
import PopUp from '../../Photos/pop up.png'
import VideoYMC from '../../Photos/¿Qué es Yo Me Controlo_.mp4'
import BackgroundBlue from '../../Photos/YMCBlockImage6.png'
import IconButton from '../../Photos/Icon 50x50px-cardiologia.png'
import '../Landing/Landing.css'
import { useNavigate } from 'react-router-dom'

export default function MedicalOrder() {
   const Navigate = useNavigate();
  return (
    <div className='MedicalOrderDiv'    style={{backgroundImage:`url(${BackgroundBlue})` , backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}} >
      <div className='MedicalOrderVideoFlex' >   
     
        <div className='MedicalOrderVideoText'>
            <div className='OrderInfoPopUp'> 
            <div className='OrderTitle'>¿Necesitas una orden médica para tus exámenes?</div>
           <div className='OrderSubtitle'>Obtén en línea tu orden médica válida en todo Chile</div>
          
         <div className='LabelButtonFlex'> 
          <div className='LabelPrice'> <span style={{fontSize:'25px', fontWeight:'300'}}>Desde </span> $1490<span style={{fontSize:'25px', fontWeight:'300'}}>CLP</span></div>
            <div className='GeneralWhiteButtonFlex' style={{paddingBlock:'0', paddingInline:'0'}} onClick={() => document.getElementById("OrderSection").scrollIntoView({ behavior: 'smooth' })} /* onClick={() => Navigate("/orden-medica")} */> 
        <div className='WitheButtonText'>
        Ir a Exámenes
        </div>
        <div className='WhiteButtonIcon'>
          <img src={IconButton}/>
        </div>
        </div>
          
            </div>
           <div className='OrderText'>Fácil, rápido y seguro</div> </div>
     </div>
        <div className='MedicalOrderVideo'>
            <video src={VideoYMC} width={'600px'}controls autoPlay muted loop  preload="metadata"/>
        </div>
      </div>
    </div>
  )
}
